import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import ForgotPasswordScreens from '../../PageComponent/Account/Forgotpassword';

export default function MySheet({ isOpen, closefun }) {
  return (
    <BottomSheet
      open={isOpen}
      onDismiss={closefun} // Close on overlay click or swipe down
      // blocking={false} // Allows closing by clicking outside
      skipInitialTransition // Prevent bounce on first render
      scrollLocking={false} // Prevent bounce on scroll
    >
      <ForgotPasswordScreens BacktoSignin={closefun} />
    </BottomSheet>
  );
}
